import React, { Component } from 'react';
import { UserConstants, SSO_AUTH_URL, GOOGLE_AUTH_URL } from '../../constants/';
import MixpanelManager from  '../../services/Analytics';
import { withStyles } from '@mui/styles';
import { LoginPage } from './login.component'
import { httpServices } from '../../services/httpServices';

class LoginConatiner extends Component{
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            submitted: false,
            forgotPassSubmitted: false,
            getOtpSubmitted: false,
            nameFormat : 'FIRSTLAST',
            info: [],
            loginError : false,
            errors : {},
            authProviders : [],
            femail: '',
            fpassword: '',
            cpassword: '',
            otp: '',
            displayFields: false,
            displayMessage: '',
            showSubmitBtn: false,
            forgotPassErrors : {},
            messageClass: 'error',
            csrfToken: '',
            resetCompleted: false,
            policyText : '',
            supportEmail : '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGetOtp = this.handleGetOtp.bind(this);
        this.onForgotPassSubmit = this.onForgotPassSubmit.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.resetPage = this.resetPage.bind(this);
    }
    componentDidMount() {
        httpServices.get('api/user/appinfo')
            .then(response => {
                if (response.data) {
                    if (response.data.auth_providers.length === 1) {
                        let auth_provider = response.data.auth_providers[0]['title'];
                        if (auth_provider ==='sso') {
                            window.location = SSO_AUTH_URL;
                        }
                        else if (auth_provider === 'google'){
                            window.location = GOOGLE_AUTH_URL;
                        }
                    }
                    this.setState({
                        info: response.data.company_info,
                        authProviders : response.data.auth_providers,
                        csrfToken: response.data.csrf_token
                    });
                    let app_title = response.data.company_info.short_name ? response.data.company_info.short_name + ' STEPS' : 'STEPS';
                    document.title = app_title; 
                }
            })
            .catch(function(error) {
            });
    }
    verifyCallback = (recaptchaToken) => {
        if (recaptchaToken) {
            this.setState({
                showSubmitBtn: true,
            })
        }
    }
    handleChange(e) {
        if (this.state.loginError === true) {
            this.setState({ 
                loginError: false  
            });
        }
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    handleSubmit(e, authmode) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.setState({ submitted: true });
            const { username, password } = this.state;
            if (username && password) {
                this.authenticate(username, password,authmode);
            }
        }
    }
    handleGetOtp(e) {
        e.preventDefault();
        let forgotPassErrors = {};
        let formIsValid = true;
        if (this.state.femail === undefined || this.state.femail.trim() == '' ) {
            formIsValid = false;
            forgotPassErrors["femail"] = "Username cannot be empty";
        }
        this.setState({
            displayMessage: '',
            messageClass: 'error',
            forgotPassErrors: forgotPassErrors
        });
        if (formIsValid) {
            let apiEndpoint = 'api/user/generateOTP';
            return httpServices.post(apiEndpoint, { 'femail': this.state.femail, 'csrf_token': this.state.csrfToken})
            .then(response => {
                if (response.data.status) {
                    this.setState({
                        displayFields: true,
                        displayMessage: response.data.message,
                        policyText : response.data.password_policy.policy_text,
                        supportEmail : response.data.support_email,
                        messageClass: 'text-approved'
                    });
                }
                else {
                    this.setState({
                        displayFields: false,
                        showSubmitBtn: false,
                        displayMessage: response.data.message,
                        messageClass: 'error'
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
        }
    }
    onForgotPassSubmit(e) {
        e.preventDefault();
        //const { femail, otp, fpassword, cpassword } = this.state;
        if (this.handleForgotPassValidation()) {
            let apiEndpoint = 'api/user/resetPassword';
            return httpServices.post(apiEndpoint, { 'femail': this.state.femail, 'otp': this.state.otp, 'fpassword': this.state.fpassword, 'cpassword': this.state.cpassword, 'csrf_token': this.state.csrfToken})
            .then(response => {
                if (response.data.status) {
                    this.setState({
                        displayMessage: response.data.message,
                        messageClass: 'text-approved',
                        resetCompleted: true
                    });
                }
                else {
                    this.setState({
                        displayMessage: response.data.message,
                        messageClass: 'error',
                        resetCompleted: false
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
        }
    }

    //login action
    authenticate(username, password, authtype) {
        let user = {
            username: username,
            password: password
        };
        let apiEndpoint = UserConstants.LOGIN_ROUTE + '?authtype=' + authtype;
        return httpServices.post(apiEndpoint, user)
            .then(response => {
                if (response.data.status) {                    
                    let mx = new MixpanelManager();
                    mx.trackEvent('Log in', { 'message': "Succefully logged in with " + username + " and auth type: " + authtype });
                    window.location = UserConstants.AFTER_LOGIN_ROUTE;                   
                }
                else {
                    this.setState({
                        loginError : true
                    });
                }
            })
            .catch(function (error) {
            });
    
    };  
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (this.state.username === undefined || this.state.username.trim() == '' ) {
            formIsValid = false;
            errors["username"] = "Cannot be empty";
        }
        if (this.state.password === undefined || this.state.password.trim() == '' ) {
            formIsValid = false;
            errors["password"] = "Cannot be empty";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleForgotPassValidation() {
        let forgotPassErrors = {};
        let formIsValid = true;
        if (this.state.femail === undefined || this.state.femail.trim() == '' ) {
            formIsValid = false;
            forgotPassErrors["femail"] = "Username cannot be empty";
        }
        if (this.state.fpassword === undefined || this.state.fpassword.trim() == '' ) {
            formIsValid = false;
            forgotPassErrors["fpassword"] = "Password cannot be empty";
        }
        if (this.state.cpassword === undefined || this.state.cpassword.trim() == '' ) {
            formIsValid = false;
            forgotPassErrors["cpassword"] = "Confirm Password cannot be empty";
        } else {
            if (this.state.fpassword !== this.state.cpassword) {
                formIsValid = false;
                forgotPassErrors["cpassword"] = "Password and Confirm Password do not match";
            }
        }
        if (this.state.otp === undefined || this.state.otp.trim() == '' ) {
            formIsValid = false;
            forgotPassErrors["otp"] = "OTP cannot be empty";
        }
        this.setState({
            displayMessage: '',
            messageClass: 'error',
            forgotPassErrors: forgotPassErrors
        });
        return formIsValid;
    }
    resetPage() {
        this.setState({
            displayMessage: '',
            messageClass: 'error'
        });
    }

    render(){
        const { classes, loggingIn, alert } = this.props;
        const { username, password, submitted ,info, forgotPassSubmitted, femail, fpassword, cpassword, otp, displayFields, getOtpSubmitted, displayMessage, messageClass, csrfToken, resetCompleted, resetPage, policyText, supportEmail } = this.state;
        return(
            <LoginPage
                username={username}
                password={password}
                submitted={submitted}
                forgotPassSubmitted={forgotPassSubmitted}
                loggingIn={loggingIn}
                alert={alert}
                onSubmit={this.handleSubmit}
                getOTP={this.handleGetOtp}
                onChange={this.handleChange}
                onForgotPassSubmit={this.onForgotPassSubmit}
                companyInfo={info}
                LoginError={this.state.loginError}
                Errors={this.state.errors}
                forgotPassErrors={this.state.forgotPassErrors}
                AuthProviders={this.state.authProviders}
                femail={femail}
                fpassword={fpassword}
                cpassword={cpassword}
                otp={otp}
                displayFields={displayFields}
                getOtpSubmitted={getOtpSubmitted}
                displayMessage={displayMessage}
                VerifyCallback={this.verifyCallback}
                showSubmitBtn={this.state.showSubmitBtn}
                messageClass={messageClass}
                csrfToken={csrfToken}
                resetCompleted={resetCompleted}
                resetPage={this.resetPage}
                PolicyText = {policyText}
                SupportEmail = {supportEmail}
            />

        );
    }
}
const connectedLoginPage = LoginConatiner;
export { connectedLoginPage as LoginPage }; 
